import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import rootReducer from "./reducers/reducers-combination/reducersCombination";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { composeWithDevTools } from "redux-devtools-extension";
import logger from "redux-logger";
import { createStore, applyMiddleware } from "redux";

const store1 = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(logger))
);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store1}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
